import { inject, Injectable, Injector } from '@angular/core'
import { initialRoleState, RoleState } from './roles.state'
import { RoleSelectors } from './roles.selectors'
import { Role } from '../interfaces/role'
import { RoleUpdaters } from './roles.updaters'
import { BaseStore } from '../base-store/base.store'

@Injectable({ providedIn: 'root' })
export class RoleStore extends BaseStore<RoleState, Role> {
  private injector = inject(Injector)
  protected override readonly initialState = initialRoleState
  readonly roles$ = this.select(RoleSelectors.selectRoles)
  //UPDATERS
  readonly setRoles = this.updater((state, roles: Role[]) => RoleUpdaters.setRoles(state, roles))

  constructor() {
    super(initialRoleState, 'RoleStore')
  }
}
